<template>
  <div class="box">
    <el-form
      :model="rule"
      :rules="rules"
      ref="rule"
      label-width="120px"
      :validate-on-rule-change="false"
    >
      <div class="title" style="margin-bottom: 12px">配送信息</div>
      <el-row>
        <el-col :span="12">
          <el-form-item label="收货人姓名" prop="recipientName">
            <el-input
              v-model="rule.recipientName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="收件人电话" prop="recipientPhone">
            <el-input
              v-model="rule.recipientPhone"
              placeholder="请输入"
              type="tel"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="收货地址" prop="recipientNote">
        <el-input v-model="rule.recipientNote" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="配送方式" prop="delivery">
        <el-radio-group v-model="rule.delivery" @change="onSwitch">
          <el-radio label="0">第三方快递</el-radio>
          <el-radio label="1">自提</el-radio>
        </el-radio-group>
      </el-form-item>
      <template v-if="rule.delivery === '0'">
        <el-row>
          <el-col :span="8">
            <el-form-item label="快递公司" prop="deliveryWay">
              <el-input
                v-model="rule.deliveryWay"
                placeholder="请输入"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item label="快递单号" prop="deliveryCode">
              <el-input
                v-model="rule.deliveryCode"
                placeholder="请输入"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item label="快递截图" prop="deliveryUrl">
              <input
                type="file"
                name="file"
                @change="getFile($event)"
              /> </el-form-item
          ></el-col>
        </el-row>
      </template>
      <template v-if="rule.delivery === '1'">
        <el-row>
          <el-col :span="8">
            <el-form-item label="姓名" prop="personalName">
              <el-input
                v-model="rule.personalName"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收件人电话" prop="personalPhone">
              <el-input
                v-model="rule.personalPhone"
                placeholder="请输入"
                type="tel"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收货地址" prop="personalNote">
              <el-input
                v-model="rule.personalNote"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <el-form-item>
        <el-button type="primary" @click="submit('rule')">提交</el-button>
        <el-button @click="block">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "edit",
      rule: {
        deliveryUrl: '',
        delivery: "0",
      },
      rules: {},
      data: {},
    };
  },
  async created() {
    if (this.$route.params.id) {
      this.$http
        .get(`/manage/outBill/detail/${this.$route.params.id}`)
        .then((results) => {
          const value = results["data"]["data"];
          if (value.deliveryWay === "自提") {
            value.delivery = "1";
            value.deliveryWay = ""
          } else {
            value.delivery = "0";
          }
          this.rule = value;
          this.data = value;
        });
    }
  },
  methods: {
    onSwitch(value) {
      this.rule.delivery = value + "";
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(+this.rule.delivery === 0) {
           this.rule.personalName = "";
           this.rule.personalPhone = "";
           this.rule.personalNote = "";
          }
          if(+this.rule.delivery === 1) {
            this.rule.deliveryWay =  "自提";
            this.rule.deliveryCode = "";
            this.rule.deliveryUrl = ""
          }
          this.$http
            .post("/manage/outBill/update",this.rule)
            .then((rs) => {
              if (rs.data.code == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.$router.push("/inventory/batch/index");
              } else {
                this.$message({
                  message: rs.data.message,
                  type: "error",
                });
              }
            });
        }
      });
    },

    block() {
      this.$router.push("/inventory/batch/index");
    },
    getFile(event) {
      var file = event.target.files;
      for (var i = 0; i < file.length; i++) {
        //    上传类型判断
        var imgName = file[i].name;
        var idx = imgName.lastIndexOf(".");
        if (idx != -1) {
          var ext = imgName.substr(idx + 1).toUpperCase();
          ext = ext.toLowerCase();
          let headers = {
            "Content-Type": "multipart/form-data",
          };
          let formData = new FormData();
          if (file[i] ) {
            formData.append("file", file[i]);
          }
          this.$http
            .post("/manage/file/upload", formData, { headers: headers })
            .then((rs) => {
              if (rs.data.code == 0) {
                this.rule.deliveryUrl = rs.data.message;
              } 
            });
        }
      }
    },
  },
};
</script>
<style scoped>
.tab {
  margin-bottom: 20px;
  margin-left: 100px;
  margin-top: 50px;
}

.box {
  display: flex;
  flex-direction: column;
  justify-content: start;
}
.title {
  font-weight: 500;
  background-color: #f1f1f1;
  width: 100%;
  line-height: 30px;
}
</style>
